import React from 'react';
import axios from 'axios';
import moment from 'react-moment';
import jwt_decode from "jwt-decode";
import * as types from '../actionTypes';
import * as config from '../../Config/api.js';

import {
  parseUserCreateError
} from '../../Components/Utils';
	

export const setUser  = (value) => { 

	return { 
		type: types.SET_USER,
		payload: value
	}
};	

// Retrieve all reservations
export const retrieveUsers_  = (data,props) => { 
		
		return dispatch => {
			
					// Check if there is a local USER OBEJECt with a TOKEN
					var result = localStorage.getItem("@dream4/userData", undefined,true);
					var userObj = JSON.parse(result);  
					
					// decode JWT 
					var decoded = jwt_decode(userObj.userToken);
								
					// Set general data
					const preparedData = {};
					preparedData.agencyId = data.agencyId;
					
					// Connect to REGISTER Endpoint
					axios({
						   url    : config.API_URL+'/api/v1/user/list',
						   method : 'POST',
						   data   : preparedData,
						   headers: {
								"x-access-token": userObj.userToken,
								Accept: 'application/json'
							}
					})							
					
					.then((response) => {

						// Document already registered
						if (!response.data.found) {
							
							props.setRows([]);
							props.setTotalRecords(0);
							props.setLoading(false);							
							return;
							
						} // end if

						if (response.data.success) {
							
							// Set list
							props.setRows(response.data.data);
							props.setTotalRecords(response.data.data.length);
							props.setLoading(false);
							return;
					
							
						} // end if
						else {
							
							props.setRows([]);	
							props.setTotalRecords(0);
							props.setLoading(false);
														
							props.setAlertTitle("Ops! Ocorreu um problema [1]");
							props.setAlertBody("Ocorreu um problema ao buscar a lista de reservas. Tente novamente. Caso o problema persista entre em  contato informando código 01.");
							props.setAlert(true);							
							return;
							
						} // end else
						
					})
					.catch(error=> {
						
						props.setRows([]);
						props.setTotalRecords(0);
						props.setLoading(false);
						
						props.setAlertTitle("Ops! Ocorreu um problema [2]");
						props.setAlertBody("Ocorreu um problema ao buscar a lista de reservas. Tente novamente. Caso o problema persista entre em contato informando código 02.");
						props.setAlert(true);							
						return;
					});
					
	} // end dispatch

};

export const retrieveUsers = (data, props) => {

  return dispatch => {

    // Check if there is a local USER OBJECT with a TOKEN
    const result  = localStorage.getItem("@dream4/userData", undefined, true);
    const userObj = JSON.parse(result || "{}");

    if (!userObj?.userToken) {
      props.setRows && props.setRows([]);
      props.setTotalRecords && props.setTotalRecords(0);
      props.setLoading && props.setLoading(false);

      props.setAlertTitle && props.setAlertTitle("Ops! Sessão inválida");
      props.setAlertBody && props.setAlertBody("Não encontramos um token de sessão. Faça login novamente.");
      props.setAlert && props.setAlert(true);
      return;
    }

    // decode JWT (caso precise extrair algo do token futuramente)
    try { jwt_decode(userObj.userToken); } catch(e) { /* silencioso */ }

    // Use o payload recebido (data) sem transformar, pois o backend já espera no formato correto
    const preparedData = { ...data };

	const url = data.isMasterUsers ? `${config.API_URL}/api/v1/masteruser/list` : `${config.API_URL}/api/v1/user/list`;

    axios({
      url    : url,
      method : 'POST',
      data   : preparedData,
      headers: {
        "x-access-token": userObj.userToken,
        Accept: 'application/json'
      }
    })
    .then((response) => {

      const res = response?.data || {};

      // Não encontrado ou vazio
      if (!res.found || res.count === 0) {
        props.setRows && props.setRows([]);
        props.setTotalRecords && props.setTotalRecords(0);
        props.setLoading && props.setLoading(false);
        return;
      }

      if (res.success) {
        const rows  = Array.isArray(res.data) ? res.data : [];
        const count = (typeof res.count === 'number') ? res.count : rows.length;

        props.setRows && props.setRows(rows);
        props.setTotalRecords && props.setTotalRecords(count);
        props.setLoading && props.setLoading(false);
        return;
      }

      // Falha controlada
      props.setRows && props.setRows([]);
      props.setTotalRecords && props.setTotalRecords(0);
      props.setLoading && props.setLoading(false);

      props.setAlertTitle && props.setAlertTitle("Ops! Ocorreu um problema [U01]");
      props.setAlertBody && props.setAlertBody(
        res?.errorMessage || "Ocorreu um problema ao buscar a lista de usuários. Tente novamente. Caso persista, informe o código U01."
      );
      props.setAlert && props.setAlert(true);
      return;

    })
    .catch(error => {

      props.setRows && props.setRows([]);
      props.setTotalRecords && props.setTotalRecords(0);
      props.setLoading && props.setLoading(false);

      props.setAlertTitle && props.setAlertTitle("Ops! Ocorreu um problema [U02]");
      props.setAlertBody && props.setAlertBody(
        (error && (error.response?.data?.errorMessage || error.message)) ||
        "Ocorreu um problema ao buscar a lista de usuários. Tente novamente. Caso persista, informe o código U02."
      );
      props.setAlert && props.setAlert(true);
      return;
    });

  }; // end dispatch

};

// Retrieve selected reservation	
export const retrieveUser  = (data,props) => { 
		
		return dispatch => {

					// Check if there is a local USER OBEJECt with a TOKEN
					var result = localStorage.getItem("@dream4/userData", undefined,true);
					var userObj = JSON.parse(result);  
					
					// decode JWT 
					var decoded = jwt_decode(userObj.userToken);

					// Set general data
					const preparedData = {};
					preparedData.agencyId = data.agencyId;
					
					// Connect to REGISTER Endpoint
					axios({
						   url    : config.API_URL+'/api/v1/agency/retrieve',
						   method : 'POST',
						   data   : preparedData,
						   headers: {
								"x-access-token": userObj.userToken,
								Accept: 'application/json'
							}
					})							
					
					.then((response) => {

						// Document already registered
						if (!response.data.found) {
							
							props.setAlertTitle("Ops! Parece que a reserva não foi encontrada!");
							props.setAlertBody("A reserva que está tentando abrir não foi encontrada. Entre em contato com o suporte e forneça o número da reserva.");
							props.setAlert(true);							
							return;
							
						} // end if

						if (response.data.success) {
							
							// Simulate delay on return
							setTimeout(function() {
								props.setLoadingData(false);
							},2000);
							
							return;
							
						} // end if
						else {
							
							props.setLoadingData(false);							
							props.setAlertTitle("Ops! Ocorreu um problema [1]");
							props.setAlertBody("Ocorreu um problema ao buscar os dados da reserva. Tente novamente. Caso o problema persista entre em  contato informando código 01.");
							props.setAlert(true);							
							return;
							
						} // end else
						
					})
					.catch(error=> {
						props.setAlertTitle("Ops! Ocorreu um problema [2]");
						props.setAlertBody("Ocorreu um problema ao buscar os dados da reserva. Tente novamente. Caso o problema persista entre em contato informando código 02.");
						props.setAlert(true);							
						return;
					});
					
	} // end dispatch


};


/**
 * Dropdown: Grupos de Pessoa (vínculo da pessoa na empresa)
 * endpoint sugerido: /api/v1/company/person-group/retrieveDropdown
 * Esperado: response.data.data = [{ id, name }, ...]
 */
export const retrieveDropdownPersonGroups = (data, props) => {
  return dispatch => {
    try {
      const raw = localStorage.getItem("@dream4/userData", undefined, true);
      const userObj = JSON.parse(raw);

      // (não usamos decoded aqui, mas padrão mantido)
      jwt_decode(userObj.userToken);

      axios({
        url: `${config.API_URL}/api/v1/user/person/group/retrieveDropdown`,
        method: 'GET',
        headers: {
          "x-access-token": userObj.userToken,
          Accept: 'application/json'
        }
      })
      .then((response) => {
        if (response.data?.success) {
          // Normaliza para {label, value} pra simplificar o Dropdown no componente
          const rows = (response.data.data || []).map(item => ({
            label: item.name || item.label || 'Sem nome',
            value: item.id   || item.value
          }));
          if (typeof props?.setRows === 'function') props.setRows(rows);
          if (typeof props?.setLoadingData === 'function') props.setLoadingData(false);
          return;
        } else {
          if (typeof props?.setRows === 'function') props.setRows([]);
          if (typeof props?.setLoadingData === 'function') props.setLoadingData(false);
          return;
        }
      })
      .catch(() => {
        if (typeof props?.setRows === 'function') props.setRows([]);
        if (typeof props?.setLoadingData === 'function') props.setLoadingData(false);
        return;
      });
    } catch (e) {
      if (typeof props?.setRows === 'function') props.setRows([]);
      if (typeof props?.setLoadingData === 'function') props.setLoadingData(false);
      return;
    }
  };
};


/**
 * Dropdown: Perfis de Usuário (perfis/acessos)
 * endpoint sugerido: /api/v1/company/user-profile/retrieveDropdown
 * Esperado: response.data.data = [{ id, name }, ...]
 */
export const retrieveDropdownUserProfiles = (data, props) => {
  return dispatch => {
    try {
      const raw = localStorage.getItem("@dream4/userData", undefined, true);
      const userObj = JSON.parse(raw);

      axios({
        url: `${config.API_URL}/api/v1/user/profile/retrieveDropdown`,
        method: 'GET',
        headers: {
          "x-access-token": userObj.userToken,
          Accept: 'application/json'
        }
      })
      .then((response) => {
        if (response.data?.success) {
          const rows = (response.data.data || []).map(item => ({
            label: item.name || item.label || 'Sem nome',
            value: item.id   || item.value
          }));
          if (typeof props?.setRows === 'function') props.setRows(rows);
          if (typeof props?.setLoadingData === 'function') props.setLoadingData(false);
          return;
        } else {
          if (typeof props?.setRows === 'function') props.setRows([]);
          if (typeof props?.setLoadingData === 'function') props.setLoadingData(false);
          return;
        }
      })
      .catch(() => {
        if (typeof props?.setRows === 'function') props.setRows([]);
        if (typeof props?.setLoadingData === 'function') props.setLoadingData(false);
        return;
      });
    } catch (e) {
      if (typeof props?.setRows === 'function') props.setRows([]);
      if (typeof props?.setLoadingData === 'function') props.setLoadingData(false);
      return;
    }
  };
};

export const retrieveDropdownAgencies = (data, props) => {
  return dispatch => {
	try {
	  const raw = localStorage.getItem("@dream4/userData", undefined, true);
	  const userObj = JSON.parse(raw);

      axios({
        url: `${config.API_URL}/api/v1/company/retrieveSelectableCompanies`,
        method: 'GET',
        headers: {
          "x-access-token": userObj.userToken,
          Accept: 'application/json'
        }
      })
      .then((response) => {

		if (response.data?.success) {
          const rows = (response.data.data || []).map(item => ({
            label: item.companyName || item.tradingName || 'Sem nome',
			subLabel: item.tradingName || 'Sem nome',
            value: item.id   || item.value
          }));
          if (typeof props?.setRows === 'function') props.setRows(rows);
          if (typeof props?.setLoadingData === 'function') props.setLoadingData(false);
          return;
        } else {
          if (typeof props?.setRows === 'function') props.setRows([]);
          if (typeof props?.setLoadingData === 'function') props.setLoadingData(false);
          return;
        }
      })
      .catch(() => {
        if (typeof props?.setRows === 'function') props.setRows([]);
        if (typeof props?.setLoadingData === 'function') props.setLoadingData(false);
        return;
      });
    } catch (e) {
      if (typeof props?.setRows === 'function') props.setRows([]);
      if (typeof props?.setLoadingData === 'function') props.setLoadingData(false);
      return;
    }
  };
};

export const retrieveRightsByProfile = (data, handlers = {}) => {
  return async (dispatch) => {
    try {
      const result = localStorage.getItem("@dream4/userData", undefined, true);
      const userObj = JSON.parse(result);
      
      const res = await axios({
        url: config.API_URL + '/api/v1/user/retrieveRightsByProfile',
        method: 'POST',
        data,
        headers: { "x-access-token": userObj.userToken, Accept: 'application/json' }
      });

      if (res?.data?.success) {
        handlers?.setRights?.(res.data.data || []);
      } else {
        handlers?.setRights?.([]);
      }
      return res?.data || { success: false };
    } catch (e) {
      handlers?.setRights?.([]);
      return { success: false, error: true };
    }
  };
};

export const createUser = (payload) => {
  return async () => {
    const raw = localStorage.getItem('@dream4/userData', undefined, true);
    const userObj = JSON.parse(raw || '{}');
    const token = userObj?.userToken;

    const { data, status } = await axios({
      url: `${config.API_URL}/api/v1/user/create`,
      method: 'POST',
      data: payload,
      headers: { 'x-access-token': token, Accept: 'application/json' },
      validateStatus: () => true, // vamos decidir aqui
    });

    if (status === 200 && data?.success) return data;

    // **Jogue o erro “como veio”** para o componente tratar
    const err = new Error(
      data?.errorMessage ||
      data?.errorContext ||
      `Falha ao criar usuário (HTTP ${status})`
    );
    err.status = status;
    err.payload = data; // mantém tudo que a API mandou
    throw err;
  };
};

export const createUser_ = (payload, handlers = {}) => {
  return async (dispatch) => {
    try {
      const result = localStorage.getItem("@dream4/userData", undefined, true);
      const userObj = JSON.parse(result);
      jwt_decode(userObj.userToken);

      const res = await axios({
        url: config.API_URL + '/api/v1/user/create',
        method: 'POST',
        data: payload,
        headers: { "x-access-token": userObj.userToken, Accept: 'application/json' }
      });

      if (res?.data?.success) {
        handlers?.onSuccess?.();
      } else {
        handlers?.onError?.(res?.data?.errorMessage);
      }
      return res?.data || { success: false };
    } catch (e) {
      handlers?.onError?.();
      return { success: false, error: true };
    }
  };
};

export const updateUser = (payload, handlers = {}) => {
  return async (dispatch) => {
	try {
	  const result = localStorage.getItem("@dream4/userData", undefined, true);
	  const userObj = JSON.parse(result);
	  jwt_decode(userObj.userToken);

	  const res = await axios({
		url: config.API_URL + '/api/v1/user/update',
		method: 'PUT',
		data: payload,
		headers: { "x-access-token": userObj.userToken, Accept: 'application/json' }
	  });

	  if (res?.data?.success) {
		handlers?.onSuccess?.();
	  } else {
		handlers?.onError?.(res?.data?.errorMessage);
	  }
	  return res?.data || { success: false };
	} catch (e) {
	  handlers?.onError?.();
	  return { success: false, error: true };
	}
  };
};

export const updatePassword = (payload, handlers = {}) => {
  return async (dispatch) => {
	try {
	  const result = localStorage.getItem("@dream4/userData", undefined, true);
	  const userObj = JSON.parse(result);
	  //jwt_decode(userObj.userToken); // não decodifica pq pode ser um token de "definir senha"

	  const res = await axios({
		url: config.API_URL + '/api/v1/user/updatePassword',
		method: 'POST',
		data: payload,
		headers: { "x-access-token": userObj.userToken, Accept: 'application/json' }
	  });

	  if (res?.data?.success) {
		handlers?.onSuccess?.();
	  } else {
		handlers?.onError?.(res?.data?.errorMessage);
	  }
	  return res?.data || { success: false };
	} catch (e) {
	  handlers?.onError?.();
	  return { success: false, error: true };
	}
  };
};

export const createPassword = (payload, handlers = {}) => {
  return async (dispatch) => {
    try {
      const res = await axios({
        url: config.API_URL + '/user/createPassword',
        method: 'POST',
        data: payload, // { authtoken, password }
        headers: { Accept: 'application/json' },
        validateStatus: () => true
      });

      const data = res?.data || {};
      const status = res?.status;

      if (status === 200 && data?.success) {
        handlers?.onSuccess?.(data);
        return data;
      }

      // Erros conhecidos com flags – devolve “como veio”
      handlers?.onError?.(data?.errorMessage || data?.transaction || 'Não foi possível criar a senha.', data);
      return data;

    } catch (e) {
      const msg = e?.response?.data?.errorMessage || e?.message || 'Falha de rede ao criar a senha.';
      handlers?.onError?.(msg);
      return { success: false, error: true, errorMessage: msg };
    }
  };
};

export const retrieveUserForEdit = (payload, handlers = {}) => {
  return async (dispatch) => {
    try {
      const raw = localStorage.getItem("@dream4/userData", undefined, true);
      const userObj = JSON.parse(raw || '{}');
      
      const res = await axios({
        url: `${config.API_URL}/api/v1/user/retrieve`,
        method: 'POST',
        data: payload, // { userId }
        headers: { "x-access-token": userObj.userToken, Accept: 'application/json' }
      });

      if (res?.data?.success && res?.data?.user) {
        handlers?.setForm?.(res.data.user);
      } else {
        handlers?.onError?.(res?.data?.errorMessage);
      }

      return res?.data || { success: false };
    } catch (e) {
      handlers?.onError?.(e?.response?.data?.errorMessage || e?.message);
      return { success: false, error: true };
    }
  };
};

export const deleteUser = (payload, handlers = {}) => {
  return async (dispatch) => {
    try {
      const raw = localStorage.getItem("@dream4/userData", undefined, true);
      const userObj = JSON.parse(raw || '{}');
      
      const res = await axios({
        url: `${config.API_URL}/api/v1/user/delete`,
        method: 'DELETE',
        data: payload, // { userId }
        headers: { "x-access-token": userObj.userToken, Accept: 'application/json' }
      });

      if (res?.data?.success) {
        handlers?.onSuccess?.();
      } else {
        handlers?.onError?.(res?.data?.errorMessage);
      }

      return res?.data || { success: false };
    } catch (e) {
      handlers?.onError?.(e?.response?.data?.errorMessage || e?.message);
      return { success: false, error: true };
    }
  };
};

// Editar usuário (admin) – POST /api/v1/user/update
export const editUser = (payload, handlers = {}) => {
  return async (dispatch) => {
    try {
      const raw = localStorage.getItem("@dream4/userData", undefined, true);
      const userObj = JSON.parse(raw || '{}');
      
      const res = await axios({
        url: `${config.API_URL}/api/v1/user/update`,
        method: 'PUT',
        data: payload, // { userId, person:{...}, user:{...}, companyId, rights:{...} }
        headers: { "x-access-token": userObj.userToken, Accept: 'application/json' }
      });

      if (res?.data?.success) {
        handlers?.onSuccess?.(res?.data?.user);
      } else {
        handlers?.onError?.(res?.data?.errorMessage);
      }

      return res?.data || { success: false };
    } catch (e) {
      handlers?.onError?.(e?.response?.data?.errorMessage || e?.message);
      return { success: false, error: true };
    }
  };
};
